import ScrollMenu from './ScrollMenu';

export default ScrollMenu;
